export default __webpack_public_path__ + "static/media/6.d9577772.jpg";